import { useMsal } from "@azure/msal-react";
import Cookies from "js-cookie";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ThreeDotLoading from "../../common-component/threedot-loading/ThreeDotLoading";
import AgoraLogo from "../../images/AgoraLogo";
import LoginIcon from "../../images/login-icon.svg";
import { getToken } from "../../service-api/axios-service/getToken";
import { loginService } from "../../service-api/loginService";
import { loginRequest } from "../../utils/msalConfig";
import "./loginPage.scss";
import { RoleGroups } from "../../roles/roleGroups";
import { useAuth } from "../../auth/AuthProvider";
import logo from "../../images/talent-hub-logo.png";

const SsoLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { setGroups } = useAuth();

  const handleLogin = () => {
    setIsLoading(true); // Start the loader
    instance
      .loginPopup(loginRequest)
      .then(async (response) => {
        const accessToken = response.accessToken;

        // Call Graph API to check membership
        const res = await fetch(
          "https://graph.microsoft.com/v1.0/me/checkMemberGroups",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              groupIds: [RoleGroups.Admin, RoleGroups.Interviewer],
            }),
          }
        );

        const graphData = await res?.json();

        // graphData.value is an array of group IDs the user belongs to
        const userGroupIds = graphData.value;

        setGroups(userGroupIds);

        // Check if user is in any allowed group
        const allowedGroupIdList = Object.values(RoleGroups);
        const isAllowed = userGroupIds.some((id) =>
          allowedGroupIdList.includes(id)
        );

        if (isAllowed) {
          fetchUserDetails(accessToken);
        } else {
          handleLogout();
        }
      })
      .catch((e) => {
        console.error("Login failed:", e);
        toast.error(e);
      })
      .finally(() => {
        setIsLoading(false); // Stop the loader
      });
  };

  const fetchUserDetails = (accessToken) => {
    loginService
      .getUserDetails(accessToken)
      .then(async (response) => {
        localStorage.setItem("user", JSON.stringify(response.data));
        getToken(navigate, setIsLoading);
      })
      .catch((err) => {
        console.error("Error fetching user details:", err);
      });
  };

  const handleLogout = () => {
    Cookies.remove("token");
    localStorage.clear();
    sessionStorage.clear();
    localStorage.clear();
    instance.getAllAccounts().forEach((acc) => {
      instance.removeAccount(acc);
    });
    navigate("/accessdenied");
  };

  return (
    <div className="app-container login-background ">
      <div className="login-form d-flex justify-content-center align-items-center position-relative ">
        <div className="title">
          <img src={logo} alt="logo" />
          <h4 className="tagline">
            Build Winning Teams
          </h4>
        </div>
        <div className="text-center position-absolute bottom-0 w-100 ">
          <button
            type="submit"
            onClick={handleLogin}
            className="btn btn-primary login-btn btn-lg w-100 rounded-top-0 "
            disabled={isLoading}
          >
            {isLoading ? (
              <ThreeDotLoading />
            ) : (
              <>
                <span className="me-2">Log in</span>
                <img src={LoginIcon} alt="Login Icon" />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SsoLogin;
